export const ISSUE_SEPARATOR = '; ';
export const MAX_ISSUES_IN_MESSAGE = 99; // I've got 99 problems but the b$tch ain't one
export const PREFIX = 'Validation error';
export const PREFIX_SEPARATOR = ': ';
export const UNION_SEPARATOR = ', or ';
